import React from 'react';
import { useTranslation } from 'react-i18next';

import { FilterOdometerIcon } from '../../assets';
import { useFilterContext } from '../../contexts/FiltersContext';
import { OdometerFilter } from '../../models/Filter';
import { printOdometerFilterValue } from '../../utils/Filters';
import BaseFilterComponent from './BaseFilterComponent';
import { StyledButton, StyledSecondaryButton } from './FiltersList.styles';
import { useRangeFilter } from './hooks/RangeFilter';
import RangeFilter from './RangeFilter';
import { InputType } from './RangeFilter/RangeFilter';
import { FilterFooterMobile } from './shared/FilterFooterMobile.styles';

const DEFAULT_ODOMETER_UNIT = 'mi';

export const AddOdometerFilterComponent = () => {
  const { t } = useTranslation();
  const min = 0;
  const max = 100000;
  const { handleApplyFilter, setOpenFiltersMobile, setSelectedFilterTitle, getSelectedFilter, handleRemoveFilter } =
    useFilterContext();

  const filter = getSelectedFilter(OdometerFilter) as OdometerFilter;

  const { getFilter, onRangeChange, range } = useRangeFilter({
    min,
    max,
    filter,
    constructor: (start, end, unit) => new OdometerFilter({ start, end, unit: unit || DEFAULT_ODOMETER_UNIT }),
  });

  const applyOnClick = () => {
    if (!getFilter) return;
    const filter = getFilter();
    handleApplyFilter(filter);
    setTimeout(() => {
      setOpenFiltersMobile(false);
      setSelectedFilterTitle('');
    }, 100);
  };

  const removeOdometerFilter = () => {
    handleRemoveFilter(filter);
    setTimeout(() => {
      setOpenFiltersMobile(false);
      setSelectedFilterTitle('');
    }, 100);
  };

  return (
    <>
      <RangeFilter
        stepValue={1}
        minValue={min}
        maxValue={max}
        values={range}
        toggleOptions={['mi', 'km']}
        toggleInitialValue={filter?.unit}
        inputType={InputType.Odometer}
        handleChange={onRangeChange}
      />
      <FilterFooterMobile>
        <StyledSecondaryButton onPress={removeOdometerFilter}>{t('filters.clearAll')}</StyledSecondaryButton>
        <StyledButton onPress={applyOnClick}>{t('filters.applyFilter')}</StyledButton>
      </FilterFooterMobile>
    </>
  );
};
const AddOdometerFilter = () => {
  const min = 0;
  const max = 100000;
  const { getSelectedFilter } = useFilterContext();
  const { t } = useTranslation();

  const filter = getSelectedFilter(OdometerFilter) as OdometerFilter;

  const { getFilter, onRangeChange, range, onCancel } = useRangeFilter({
    min,
    max,
    filter,
    constructor: (start, end, unit) => new OdometerFilter({ start, end, unit: unit || DEFAULT_ODOMETER_UNIT }),
  });

  const printValue = printOdometerFilterValue(filter, t);

  return (
    <BaseFilterComponent
      getFilter={getFilter}
      icon={<FilterOdometerIcon />}
      title={t('filters.odometer')}
      onCancel={onCancel}
      inUse={!!filter}
      storedFilter={filter}
      printedValues={printValue}
    >
      <RangeFilter
        stepValue={1}
        minValue={min}
        maxValue={max}
        values={range}
        toggleOptions={['mi', 'km']}
        toggleInitialValue={filter?.unit}
        inputType={InputType.Odometer}
        handleChange={onRangeChange}
      />
    </BaseFilterComponent>
  );
};

export default AddOdometerFilter;
